import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function Loacation() {
    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">
                {/* Background Glow */}
                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                           Location
                        </span>
                    </div>

                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Location{" "}
                            <span className="text-dark-gold">
                                Us
                            </span>
                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed mb-8">
                            SBI Capital Markets Limited (SBICAPS) is registered with SEBI as a category I Merchant Banker (Registration No. INM000003531) and a Research Analyst (Registration No. INH000007429).
                        </p>
                       
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}
